import { format } from "currency-formatter";

export function formatCurrency(value: number) {
  return format(value, {
    code: "VND",
    thousand: ",",
    decimal: ".",
  });
}
